<div class="footer">
    <div class="container text-center">
        <div class="row">
          <!-- <div class="col-md-12 text-center">
              <img style="margin-top: 4px;" width="200px" src="./assets/images/culturalexportfund.png" title="Powered by: WebMonkeyz" alt="WebMonkeyz" />
          </div> -->

          <div class="col-md-12 text-center" style="margin-top:10px;">
            <!-- <img src="../../../assets/images/record-label-logo.png" width="100px" /> -->
            <!-- <img src="../../../assets/images/edel-logo.png" width="100px" /> -->
            <img src="../../../assets/images/shellshock-logo.png" width="100px" />
            <!-- <img src="../../../assets/images/flaming-logo.png" width="120px" /> -->
            <!-- <img src="../../../assets/images/rock-logo.png" width="100px" /> -->
            <img src="../../../assets/images/arts-logo.png" width="75px" />
        </div>

          <div class="col-md-12 text-center">
              <a href="https://www.facebook.com/angelcrypt/" target="_blank"><i class="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/angelcrypt/" target="_blank"><i class="fab fa-instagram"></i></a>
              <a href="https://www.youtube.com/user/angelcrypt" target="_blank"><i class=" fab fa-youtube"></i></a>
              <a href="https://twitter.com/angelcryptband" target="_blank"><i class="fab fa-twitter"></i></a>
          </div>

          <p class="col-md-12 text-center">"Angelcrypt™", the Angelcrypt™ logo and the bullets, skull & wings emblem are registered trademarks.
              <br />All rights reserved. © Angelcrypt {{year}}</p>

          <div class="col-md-12 text-center">
              <a target="_blank" href="https://www.webmonkeyz.com"><img style="margin-top: 4px;" width="40px" src="./assets/icons/webmonkeyz-logo.svg" title="Powered by: WebMonkeyz" alt="WebMonkeyz" /></a>
          </div>
        </div>
    </div>
</div>